import Github from '../image/github.svg';
import Linkedin from '../image/linkedin.svg';
import Medium from '../image/medium.svg';

const Footer = () => {
  return (
    <div className='flex flex-col items-center lg:bg-transparent font-mono'>
      <div className='flex lg:flex-col justify-center lg:justify-end items-end w-full gap-4 px-6 my-10'>
        <a href='https://github.com/Feruzteame' target='_blank' rel='noreferrer'>
          <img src={Github} alt='github' className='h-8 w-8 cursor-pointer hover:scale-150 transform transition-transform transition-500' />
        </a>
        <a href='https://linkedin.com/in/feruz-teame' target='_blank' rel='noreferrer'>
          <img src={Linkedin} alt='linkedin' className='h-8 w-8 cursor-pointer hover:scale-150 transform transition-transform transition-500' />
        </a>
        <a href='https://medium.com/@feruzTeame' target='_blank' rel='noreferrer'>
          <img src={Medium} alt='medium' className='h-8 w-8 cursor-pointer hover:scale-150 transform transition-transform transition-500' />
        </a>
      </div>
    </div>
  );
};

export default Footer;